import SplitText from '@activetheory/split-text'
import gsap from 'gsap'

import { SharedAnimation } from './shared'
import { Animation } from '@/types'

export const animation = (
  root: gsap.DOMTarget,
  target: HTMLElement,
  reverse: boolean
): SharedAnimation => {
  const splitted = new SplitText(target, {
    type: 'words,chars',
    noBalance: true
  })

  const fromColor = gsap.getProperty(target, 'color')
  const toColor = root instanceof HTMLElement ? root.dataset?.fill : ''

  return {
    timeline: gsap
      .timeline({
        onComplete: () => {
          if (reverse) return
          splitted.revert()
        }
      })
      .fromTo(
        splitted.chars,
        { color: fromColor },
        {
          color: toColor,
          ease: 'power3.out',
          stagger: 0.1,
          duration: 1.6
        },
        '<'
      ),

    revert: () => {
      splitted.revert()
    }
  }
}

export const karaokeText = ({ node, reverse, context }: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const text = selector('[data-motion-karaoke]')[0]

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%',
    end: 'bottom center',
    scrub: 0.8
  }

  const timeline = gsap.timeline({
    scrollTrigger
  })

  let textAnimation: SharedAnimation
  if (text) {
    textAnimation = animation(node, text, reverse)
    timeline.add(textAnimation.timeline, '<')
  }

  return () => {
    if (text) {
      textAnimation.revert()
    }
  }
}
